import axios from 'axios';

const API_URL = '/api/send_inquiry.php';

export const sendInquiry = async (inquiryData: any) => {
    try {
        const response = await axios.post(API_URL, inquiryData);
        return response.data;
    } catch (error) {
        throw new Error('Error sending inquiry');
    }
};
